import ExportPrototypeModulesListRequestModelBase from '../_generated/modelBases/export-prototype-modules-list-request-model-base';

export default class ExportPrototypeModulesListRequestModel extends ExportPrototypeModulesListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
